import { DataSourceMode, Layout, SlideoutDecorator } from "@mcleod/components";
import { AutogenLayoutReplaceUserErrorSlideout } from "./autogen/AutogenLayoutReplaceUserErrorSlideout";
import { ModelRow } from "@mcleod/core";

export class ReplaceUserErrorSlideout extends AutogenLayoutReplaceUserErrorSlideout {
    public static async showSlideout(failed: []) {
        const layout = Layout.getLayout("lme/crm/ReplaceUserErrorSlideout") as ReplaceUserErrorSlideout;

        return new SlideoutDecorator({
            title: "Update Error(s)",
            layout: layout,
            width: "65%",
            fillVerticalSpace: true,
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                layout.mainDataSource.setRowsAndMode(DataSourceMode.NONE,
                    failed.map((fail: any) => new ModelRow(layout.mainDataSource.url, false, fail))
                );
                layout.labelFailCount.text = failed.length.toString();
            },
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            }
        });
    }
}